import { useCallback, useMemo, useState } from "react";

import { FormCategory, ReportSearch } from "../../../../../../../__generated__/graphql";
import { FilterSettings } from "../../../../../hooks/filtering/useFilterFromUrlParams";

export function useFilterSettings(defaultValue: ReportSearch) {
  const defaults = useMemo<ReportSearch>(() => ({ excludeSpam: true, category: FormCategory.Reporting }), []);
  const [filter, setFilter] = useState(defaultValue);
  const clearFilters = useCallback(() => setFilter(defaults), [defaults]);
  return useMemo<FilterSettings>(
    () => ({
      filter,
      setFilter,
      clearFilters,
      forbiddenFilters: {
        createdAt: true,
        updatedAt: false,
        status: false,
        assignedTo: false,
        outcome: false,
        form: false,
        questions: false,
        excludeSpam: false,
        redactionStatus: false,
      },
      defaults,
    }),
    [clearFilters, defaults, filter],
  );
}
